'use strict';
import {settings} from '../../../variables.js'
var apiBaseUrl = settings.apiBaseUrl

angular.
module('core.contacts')
    .factory('Contact', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/contacts/api/consult/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
    .factory('ShelfOrder', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/contacts/api/shelf-order/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
    .factory('ContactOpt', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/contacts/api/opt/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
    .factory('ContactPrice', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/contacts/api/less-price/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
    .factory('CallMe', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/contacts/api/callme/',
            {},
            {
                save: {
                    method: 'PUT'
                }
            }
        )
    }])
;